import { Icon } from "semantic-ui-react";

import { QuestionResultStatusSelector } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components";
import { TyreActionSelector } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components/TyreQuestionResults/components/TyreTable/components/TyreTableRow/components/TyreActions/components";
import { parseQuestionResultAttachments } from "modules/AppointmentDetails/utils";

import type { Appointment, ChecklistTemplate, QuestionResult } from "models";

type TyreActionsProps = {
  questionResult: QuestionResult;
  appointment: Appointment;
  template?: ChecklistTemplate | null;
  toggleShowMedia?: () => void;
  readOnly?: boolean;
};

export const TyreActions = ({ questionResult, template, toggleShowMedia, appointment, readOnly }: TyreActionsProps) => {
  const attachments = parseQuestionResultAttachments(questionResult);

  return (
    <div className="tyre-action">
      <div className="tyre-container">
        <QuestionResultStatusSelector questionResult={questionResult} disabled={readOnly} />

        {attachments.length > 0 && (
          <div onClick={toggleShowMedia}>
            <Icon className="images grey pointer" size="small" />
            <p>
              <small>{attachments.length}</small>
            </p>
          </div>
        )}

        <TyreActionSelector questionResult={questionResult} template={template} appointment={appointment} readOnly={readOnly} />
      </div>
    </div>
  );
};
